import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  PlusCircle,
  Edit,
  Trash2,
} from "feather-icons-react/build/IconComponents";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { getAllWarehouses, deleteWarehouse } from "../../core/api/settings";
import Table from "../../core/pagination/datatable";
import WarehouseDetailsView from "./warehousedetailsview";
import { useSelector } from "react-redux";
import { message } from "antd";

const Warehouses = () => {
  const [warehouses, setWarehouses] = useState([]);
  const [isWarehouseDetailsVisible, setWarehouseDetailsVisible] =
    useState(false);
  const [currentWarehouseId, setCurrentWarehouseId] = useState(null);
  const MySwal = withReactContent(Swal);
  const [loading, setLoading] = useState(false);
  const selectedClients = useSelector((state) => state.selectedClients);
  const [clientId, setClientId] = useState(null);

  const loadWarehouses = async () => {
    setLoading(true);
    try {
      const response = await getAllWarehouses(selectedClients);
      setWarehouses(response.data);
    } catch (err) {
      console.error("Failed to fetch warehouses", err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    loadWarehouses();
  }, [selectedClients]);

  const showConfirmationAlert = (warehouseId) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deleteWarehouse(warehouseId);
          setWarehouses((prevWarehouses) =>
            prevWarehouses.filter((warehouse) => warehouse.id !== warehouseId)
          );
          MySwal.fire({
            title: "Deleted!",
            text: "The warehouse has been deleted.",
            icon: "success",
          });
        } catch (err) {
          console.error("Failed to delete warehouse", err);
          MySwal.fire({
            title: "Error!",
            text: "Failed to delete warehouse.",
            icon: "error",
          });
        }
      } else {
        MySwal.close();
      }
    });
  };

  const [sidebarWidth, setSidebarWidth] = useState(0);

  const handleAddWarehouse = () => {
    if (!selectedClients) {
      message.warning("Please select a client.");
      return;
    }
    if (selectedClients.length === 0) {
      message.warning("Please select a client.");
      return;
    }

    if (selectedClients.length > 1) {
      message.warning("Please select one client.");
      return;
    }

    if (selectedClients[0] === "all") {
      message.warning("Please select one client.");
      return;
    }
    setClientId(selectedClients[0]);
    setCurrentWarehouseId(null);
    setWarehouseDetailsVisible(true);
  };

  const handleEditWarehouse = (warehouseId, clientId) => {
    setCurrentWarehouseId(warehouseId);
    setClientId(clientId);
    setWarehouseDetailsVisible(true);
  };

  const handleCloseWarehouseDetails = () => {
    setWarehouseDetailsVisible(false);
    setCurrentWarehouseId(null);
  };
  const brandWarehouseMap = new Map();
  warehouses.forEach((warehouse) => {
    const brandKey = warehouse.brand_name;
    if (!brandWarehouseMap.has(brandKey)) {
      brandWarehouseMap.set(brandKey, []);
    }
    brandWarehouseMap.get(brandKey).push(warehouse);
  });
  const transformedWarehouses = [];
  let rowIndex = 0;
  brandWarehouseMap.forEach((brandWarehouses, brandName) => {
    const brandRowSpan = brandWarehouses.reduce(
      (sum, wh) => sum + wh.addresses.length,
      0
    );
  let currentBrandStartIndex = rowIndex;
  brandWarehouses.forEach((warehouse) => {
    const warehouseRowSpan = warehouse.addresses.length;
    warehouse.addresses.forEach((address, index) => {
      transformedWarehouses.push({
        key: `${warehouse.id}-${address.id}`, // Unique key for each row
        warehouseId: warehouse.id, // Store warehouse id for later reference
        brand_name: index === 0 && rowIndex === currentBrandStartIndex ? warehouse.brand_name : "", // Only show the brand name on the first row
        warehouseName: index === 0 ? warehouse.name : "", // Only show the warehouse name on the first row
        addressName: address.name,
        address: address.address,
        contactName: address.contact_name,
        email: address.email,
        phoneNumber: address.phone_number,
        action:
          index === 0 ? (
            <div className="action-table-data">
              <div className="edit-delete-action">
                <Link
                  to="#"
                  className="me-2 p-2"
                  title="Edit"
                  onClick={() => handleEditWarehouse(warehouse.id, warehouse.client_id)}
                >
                  <Edit className="feather-edit" />
                </Link>
                <Link
                  to="#"
                  onClick={() => showConfirmationAlert(warehouse.id)}
                  className="p-2"
                  title="Delete"
                >
                  <Trash2 className="feather-trash-2" />
                </Link>
              </div>
            </div>
          ) : (
            ""
          ),// Empty if not the first row
          _rowMeta: {
            brandRowSpan:
              index === 0 && rowIndex === currentBrandStartIndex
                ? brandRowSpan
                : 0,
            warehouseRowSpan: index === 0 ? warehouseRowSpan : 0,
          },
        });

        rowIndex++;
      });
    });
  });

  const columns = [
    {
      title: "Brand",
      dataIndex: "brand_name",
      width: 150,
      render: (_, record) => ({
        children: _,
        props: {
          rowSpan: record._rowMeta?.brandRowSpan || 0,
        },
      }),
    },
    {
      title: "Warehouse Name",
      dataIndex: "warehouseName",
      width: 170,
      render: (_, record) => ({
        children: _,
        props: {
          rowSpan: record._rowMeta?.warehouseRowSpan || 0,
        },
      }),
    },
    {
      title: "Address Name",
      dataIndex: "addressName",
      width: 100,
    },
    {
      title: "Address",
      dataIndex: "address",
      width: 300,
    },
    {
      title: "Contact Name",
      dataIndex: "contactName",
      width: 150,
    },
    {
      title: "Email Address",
      dataIndex: "email",
      width: 200,
    },
    {
      title: "Phone Number",
      dataIndex: "phoneNumber",
      width: 150,
    },
    {
      title: "Action",
      dataIndex: "action",
      width: 150,
      fixed: "right",
      render: (_, record) => ({
        children: _,
        props: {
          rowSpan: record._rowMeta?.warehouseRowSpan || 0,
        },
      }),
    },
  ];

  return (
    <div>
      <div
        className="content"
        style={{
          width: isWarehouseDetailsVisible
            ? `calc(100% - ${sidebarWidth}px)`
            : "100%",
          transition: "width 0.3s ease-in-out",
        }}
      >
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Warehouses List</h4>
              <h6>Manage your warehouses</h6>
            </div>
          </div>
          <div className="page-btn">
            <button className="btn btn-added" onClick={handleAddWarehouse}>
              <PlusCircle className="me-2 iconsize" />
              Add New Warehouse
            </button>
          </div>
        </div>

        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm formsearch"
                  />
                  <Link to="#" className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </Link>
                </div>
              </div>
            </div>

            <div className="table-responsive">
              <Table
                columns={columns}
                dataSource={transformedWarehouses}
                loading={loading}
              />
            </div>
          </div>
        </div>
      </div>

      <WarehouseDetailsView
        isVisible={isWarehouseDetailsVisible}
        onClose={handleCloseWarehouseDetails}
        warehouseId={currentWarehouseId}
        setWarehouseId={setCurrentWarehouseId}
        onResize={setSidebarWidth}
        loadWarehouses={loadWarehouses}
        clientId={clientId}
      />
    </div>
  );
};

export default Warehouses;
